<template>
  <div class="container">
    <HeadingOne class="-margin-md">口座のご登録</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="2" type="entry"></MainWizard>
    </WizardGroup>

    <NoticeBox class="-error _textleft">
      <NoticeHeader>
        <h2 class="heading">
          ご指定の口座ではご登録することができませんでした。
        </h2>
      </NoticeHeader>
      <NoticeBody>
        <ListGroup class="-normal">
          <ListItem class="-normal"
            >口座のご名義がご本人さまと異なっている</ListItem
          >
          <ListItem class="-normal"
            >本サービスが対応していない金融機関</ListItem
          >
        </ListGroup>
        <span
          >上記等はご利用することができません。誠に申し訳ございませんが、下記のボタンより再度ご本人さま確認をお願い致します。</span
        >
      </NoticeBody>
    </NoticeBox>

    <BtngroupSingle class="-margin-lg _mb-md-20 _mb-sm-20">
      <BtnMain class="-main btn-1" router-name="en006" :query="{ state: '2' }"
        >別の口座を登録する</BtnMain
      >
    </BtngroupSingle>

    <BtngroupSingle class="_mb-md-120 _mb-sm-60">
      <BtnMain class="-main btn-2" router-name="en007"
        >ご本人さま確認書類のご提出を行う</BtnMain
      >
    </BtngroupSingle>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
export default {
  name: "Tem004",
  components: {
    BtnMain,
    BtngroupSingle,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
    ListGroup,
    ListItem,
  },
  setup() {
    setMeta({
      title: "口座のご登録",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,口座登録",
    });
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-main.btn-1 {
  @include mq-up(md) {
    font-size: 19px;
  }
}

.btn-main.btn-2 {
  @include mq-up(md) {
    font-size: 19px;
    padding-left: 5px;
  }
}
</style>
